<template>
  <!-- Price Section start-->
  <v-container fluid class="cards-container">
    <Feature>
<template slot="buy-basic">
  <v-btn
                  depressed
                  color="#18e7d3"
                  height="30px"
                  width="100px"
                  class="price-group-purchase-btn"
                  role="button"
                  @click="onBuyBasic"
                  >{{ $lang.payment.buy }}</v-btn
                >

</template>

<template slot="buy-premium">
  <v-btn
                  depressed
                  color="#18e7d3"
                  height="30px"
                  width="100px"
                  class="price-group-purchase-btn"
                  role="button"
                  @click="onBuyPremium"
                  >{{ $lang.payment.subscribe }}</v-btn
                >

</template>

<template slot="buy-bulk">
  <v-btn
                  depressed
                  color="#18e7d3"
                  height="30px"
                  width="100px"
                  class="price-group-purchase-btn"
                  role="button"
                  @click="onBuyCorp"
                  >{{ $lang.payment.subscribe }}</v-btn
                >

</template>
    </Feature>
    <!-- <section id="price" class="price">
      <div class="container">
        <div class="row">
          <div class="price-carousel">
            <v-card class="price-item col-md-4 col-sm-12">
              <div class="price-block">
                <div class="price-type">
                  <h2>{{ $lang.payment.title_basic }}</h2>
                  <h3 class="price-type-description">
                    {{ $lang.payment.title_pay_as_you_go }}
                  </h3>
                </div>
                <div class="mrp">
                  <h6 class="user-type"></h6>
                  <div class="top-devide price-devide"></div>
                  <h2>
                    <span :class="isMonthlySubscribers ? 'premium-cost' : ''"
                      >${{ basicCost }}</span
                    ><span v-show="isMonthlySubscribers"
                      >${{ isPremium ? premiumCost : premiumCorpCost }}</span
                    ><span style="font-size: 14px">{{ $lang.common.usd }}</span>
                  </h2>

                  <h6 class="price-year">{{ $lang.payment.per_hour }}</h6>
                  <div v-show="$lang.getLang() === 'zh'" class="price-alt">
                    (${{
                      isMonthlySubscribers
                        ? isPremium
                          ? premiumCost * 30
                          : premiumCorpCost * 30
                        : basicCost * 30
                    }}
                    NTD)
                  </div>
                  <div class="price-devide"></div>
                </div>

                <v-btn
                  depressed
                  color="#18e7d3"
                  height="50px"
                  width="100%"
                  class="btn btn-custom theme-color"
                  role="button"
                  @click="onBuyBasic"
                  >{{ $lang.payment.buy }}</v-btn
                >
              </div>
            </v-card>
            <v-card class="price-item col-md-4 col-sm-12">
              <div class="price-block" :class="isPremium ? 'premium' : ''">
                <div class="price-type">
                  <h2>{{ $lang.payment.title_premium }}</h2>
                  <h3 class="price-type-description">
                    {{ $lang.payment.title_subscription }}
                  </h3>
                </div>
                <div class="mrp">
                  <h6 class="user-type"></h6>
                  <div class="top-devide price-devide"></div>
                  <h2>
                    ${{ subscriptionCost
                    }}<span style="font-size: 14px">{{
                      $lang.common.usd
                    }}</span>
                  </h2>
                  <h6 class="price-year">{{ $lang.payment.per_month }}</h6>
                  <div v-show="$lang.getLang() === 'zh'" class="price-alt">
                    (${{ subscriptionCost * 30 }} NTD)
                  </div>
                  <div class="price-devide"></div>
                </div>
                <v-btn
                  depressed
                  color="#18e7d3"
                  height="50px"
                  width="100%"
                  v-show="!isMonthlySubscribers"
                  class="btn btn-custom theme-color"
                  role="button"
                  @click="onBuyPremium"
                  >{{ $lang.payment.subscribe }}</v-btn
                >
                <h5 v-show="isPremium" class="activate">
                  {{ $lang.payment.activate }}
                </h5>
              </div>
            </v-card>
            <v-card class="price-item col-md-4 col-sm-12">
              <div class="price-block" :class="isCorp ? 'premium' : ''">
                <div class="price-type">
                  <h2>{{ $lang.payment.title_corp }}</h2>
                  <h3 class="price-type-description">
                    {{ $lang.payment.title_subscription }}
                  </h3>
                </div>
                <div class="mrp">
                  <h6 class="user-type"></h6>
                  <div class="top-devide price-devide"></div>
                  <h2>
                    ${{ corpCost
                    }}<span style="font-size: 14px">{{
                      $lang.common.usd
                    }}</span>
                  </h2>
                  <h6 class="price-year">{{ $lang.payment.per_month }}</h6>
                  <div v-show="$lang.getLang() === 'zh'" class="price-alt">
                    (${{ corpCost * 30 }} NTD)
                  </div>
                  <div class="price-devide"></div>
                </div>

                <v-btn
                  depressed
                  color="#18e7d3"
                  height="50px"
                  width="100%"
                  v-show="!isMonthlySubscribers"
                  class="btn btn-custom theme-color"
                  role="button"
                  @click="onBuyCorp"
                  >{{ $lang.payment.subscribe }}</v-btn
                >
                <h5 v-show="isCorp" class="activate">
                  {{ $lang.payment.activate }}
                </h5>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </section> -->
    <div class="pricing-inquiries" v-html="$lang.payment.upgrade_contact_us">{{$lang.payment.upgrade_contact_us}}</div>
   <price-table></price-table>
 
  </v-container>
</template>

<script>
import Feature from "@/components/landing/Feature.vue";
 import PriceTable from "@/components/common/PriceTable";
import textHelper from "@/utils/textManager";
export default {
  name: "PriceSection",
  data() {
    return {
      supportedLanguages: "",
      supportedTranslatedLanguages: "",
      promotionMinutes: "",
      corpPromotionMinutes: "",
    };
  },
  components: {
    PriceTable,
    Feature
  },
  props: [
    "basicCost",
    "premiumCost",
    "premiumCorpCost",
    "subscriptionCost",
    "corpCost",
    "translateCost",
  ],
  methods: {
    sendMail() {
      const me = this;
      const option = {
        title: me.$lang.account.thank_you_interest,
        description: me.$lang.account.reach_out.format(
          process.env.VUE_APP_CONTACT_EMAIL
        ),
        persistent: true,
        width: 360,
        ok: me.$lang.editing.reset_ok,
        className: "success-dialog single",
      };

      me.$globalConfirmationDialog.open(option);
    },
    onBuyBasic() {
      const me = this;
      me.$emit("buy-basic");
    },
    onBuyPremium() {
      const me = this;
      me.$emit("buy-premium");
    },
    onBuyCorp() {
      const me = this;
      me.$emit("buy-corp");
    },
    // onUpgradeCorp(){
    //   const me = this
    //   me.$emit('upgrade-corp');
    // }
  },
  computed: {
    isMonthlySubscribers() {
      return false;
    },
    isPremium() {
      return false;
    },
    isCorp() {
      return false;
    },
  },
  mounted() {
    const me = this;
    const distinctLang = textHelper.distinctLanguages(me.$lang.language);
    const distinctTransLang = textHelper.distinctLanguages(
      me.$lang.translatelanguage
    );

    //me.reset()
    distinctLang.forEach(function (code, index) {
      me.supportedLanguages += '<span class="cell">' + code + "</span>";
      if ((index + 1) % 3 === 0) {
        me.supportedLanguages += "</br>";
      } else {
        me.supportedLanguages += " ";
      }
    });

    distinctTransLang.forEach(function (code, index) {
      me.supportedTranslatedLanguages +=
        '<span class="cell">' + code + "</span>";
      if ((index + 1) % 3 === 0) {
        me.supportedTranslatedLanguages += "</br>";
      } else {
        me.supportedTranslatedLanguages += " ";
      }
    });

    me.supportedTranslatedLanguages += `<div class="tooltip-note">*${me.$lang.payment.basic_feature4_tooltip}</div>`;
    me.corpPromotionMinutes = me.$lang.payment.premium_feature1.format(
      '<span style="color: #00d1b2;">1000</span>'
    );
    me.promotionMinutes = me.$lang.payment.premium_feature1.format(
      '<span style="color: #00d1b2;">120</span>'
    );
  },
  created() {},
};
</script>

<style scoped>
>>> .price .v-btn__content {
  color: white;
}
.btn.contact-us {
  height: 50px !important;
}

.btn.contact-us i {
  font-size: 16px;
  margin-right: 20px;
}

h2.contact-us {
  font-size: 25px !important;
  margin-bottom: 44px;
  font-weight: lighter;
  letter-spacing: 0.1em;
  margin-top: 45px;
}

.price a.contact-us {
  text-decoration: underline;
  position: absolute;
  right: 25px;
  top: 20px;
}

.price-block .btn-custom {
  position: absolute;
  bottom: 0px;
  left: 0px;
  margin-bottom:0px;
}

.premium-cost {
  text-decoration-line: line-through;
  font-weight: 100 !important;
  color: lightgray !important;
}

.price {
  width: 100%;
  filter: saturate(0.6);
  padding-bottom: 0px;
}

.price-devide {
  height: 1px;
  background-color: #eee;
  width: 245px;
  margin: 0 auto;
}

.price-item .top-devide {
  margin-bottom: 32px;
  margin-top: 10px;
}

.price-type {
  background-image: none;
}

.premium .price-type {
  padding-top: 10px;
}
.price-block {
  height: 100%;
  padding: 0px;
}

.price-block.premium {
  border: 10px solid #92fbe2;
  background: #e2f8f2;
}
.price-feature {
  text-align: left;
  margin-bottom: 5px;
  padding-left: 0px;
  min-height: 260px;
  font-weight: bold;
}
.price-feature li {
  text-align: center;
}
.price-type h2 {
    color:#2fc59f!important;
  font-weight: 300;
  letter-spacing: 0.1em;
  font-size: 24px;
  background: transparent;
  padding: 10px;
  text-align: center;
  /* color: #18e7d3; */
  margin-bottom: 0px !important;
  font-weight: 400;
}
.price-item {
  height: 320px;
}
.price-item .activate {
  color: #2fc59f !important;
}

.mrp h2 {
  font-weight: bold;
  color: black;
  margin-bottom: 0px !important;
}

.pricing-inquiries{
  padding: 10px 25px;
    border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
    margin-bottom: -1px;
    background: white;
    color: #797676;
    font-size: 13px;
    font-weight: bold;
    margin-right:20px;
    display:none;
    /* margin-top:20px; */
}

.dark h6,
.dark .price-feature li,
.dark .price-feature li span {
  color: white !important;
}
.dark .pricing-inquiries{
  background:#3A3B3C!important;
  background-color: #3A3B3C!important;
}
</style>
<style>
.price-type-description {
  margin-top: 0px;
}

.price-carousel {
  width: 100% !important;
  display: flex;
}

.price-carousel .price-item {
  /* max-width: 30%; */
  margin-right: 20px;
  border-radius: 6px;
  flex:1;
}

.price-notes {
  font-size: 14px;
  font-weight: 100;
  color: #bababa;
}

.owl-item.active {
  max-width: 400px !important;
}
.mrp {
  position: relative;
}
.price-alt {
  /* position: absolute; */
  top: 90px;
  margin: 0 auto;
}
.price-year {
  margin-bottom: 30px !important;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #777;
}
/* @media only screen and (max-device-width: 992px) {

.pricing-inquiries{
  display:block;
}
} */

@media only screen and (max-device-width: 600px) {
  .price-carousel {
    display: block;
  }
  .price-carousel .price-item {
    max-width: 100%;
  }
  .price-block .btn {
    width: 100%;
  }

  .upgrade-container {
    padding: 0px;
  }
  .price-item {
    margin: 0px !important;
    padding-right: 0px;
  }
  .upgrade-container .price-block .contact-us {
    left: 0;
    bottom: 50px !important;
    right: auto !important;
    /* margin: 0 auto; */
    top: 70px !important;
    text-align: center;
    position: relative !important;
    width: 100%;
    margin-top: 110px;
  }
  .upgrade-container .price-table {
    border: 1px lightgray solid;
    padding: 10px;
    margin-right: 0px !important;
  }

  .pricing-inquiries{
  padding: 10px 10px;
    margin-right: 0px !important;
}

  .cards-container .container,
  .cards-container {
    padding: 0px;
  }
}
</style>
